/** Default landing path for a signed-in role. */
export function homeFor(role: string) {
  switch (role) {
    case "guard":
      return "/guardia";
    case "admin":
      return "/admin";
    case "platform_admin":
      return "/platform";
    case "billing_contact":
      return "/platform/facturacion";
    default:
      return "/";
  }
}
